// @flow
import type { Element } from 'react';
import React, { Component } from 'react';
import { View } from 'react-native';
import type { NavigationRoute, NavigationScreenProp } from '@react-navigation/compat';
import ContractsItemsPickerButton from '../Contracts/components/ContractsItemsPickerButton';
import I18n from '../../lib/i18n';
import type { AgreementSpecification, TrpcFile } from 'digicel-kaizen-library';
import { openFileByFileOuid, openStaticFileByFileName } from '../../lib/openURL';

class CheckDocuments extends Component<Props, State> {
  state = {
    isLoading: false,
  };

  onContractPress = (fileName: string, fileOuid: string) => () => {
    const contractFileName = fileName.replace('.html', '');
    this.setState({ isLoading: true }, () => {
      openFileByFileOuid(contractFileName, fileOuid, this.props.token).finally(() =>
        this.setState({ isLoading: false })
      );
    });
  };

  onAgreementPress = (fileName: string) => () => {
    openStaticFileByFileName(fileName);
  };

  renderContracts = () => {
    const { contracts } = this.props;

    if (contracts) {
      return contracts.map<Element<*>>(contract => (
        <ContractsItemsPickerButton
          isLoading={this.state.isLoading}
          key={contract.ouid}
          label={I18n.t('Dashboard.CheckDocuments.contractType.CONTRACT')}
          onPress={this.onContractPress(contract.fileName, contract.ouid)}
        />
      ));
    }
  };

  renderAgreements = () => {
    const { agreements } = this.props;

    return agreements.map<?(Element<*>[])>(agreement => {
      const agreementAttachments = agreement.agreementAttachments;

      return (
        agreementAttachments &&
        agreementAttachments.map<Element<*>>(attachment => (
          <ContractsItemsPickerButton
            key={attachment.id}
            onPress={this.onAgreementPress(attachment.id)}
            label={I18n.t(`agreement.${agreement.name}.attachment.${attachment.type}`)}
          />
        ))
      );
    });
  };

  render() {
    return (
      <View>
        {this.renderContracts()}
        {this.renderAgreements()}
      </View>
    );
  }
}

type State = {
  isLoading: boolean,
};

type Props = StateProps & {
  navigation: NavigationScreenProp<NavigationRoute>,
};

type StateProps = {
  agreements: AgreementSpecification[],
  contracts: TrpcFile[],
  token: string,
};

export default CheckDocuments;
